import { render, staticRenderFns } from "./V2CourseProgress.vue?vue&type=template&id=47990bc3&scoped=true&"
import script from "./V2CourseProgress.vue?vue&type=script&lang=js&"
export * from "./V2CourseProgress.vue?vue&type=script&lang=js&"
import style0 from "./V2CourseProgress.vue?vue&type=style&index=0&id=47990bc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47990bc3",
  null
  
)

export default component.exports